import { Navigate, Route, Routes } from 'react-router-dom';
import { PublicRoute } from './PublicRoutes';
import { PrivateRoute } from './PrivateRoutes';
import { DashboardRoutes } from './DashboardRoutes';
import LoginPage from '../pages/login/LoginPage';
import ChangePassword from '../pages/login/ChangePassword';
import VoucherPage from '../pages/invoice/voucherPage';
import { InvoiceProvider } from '../context/invoice/InvoiceContext';
import { MenuQRProvider } from '../context/menu/MenuQRContext';
import MenuQRPage from '../pages/menu-qr/MenuQRPage';
import ConfirmOrderPage from '../pages/menu-qr/ConfirmOrderPage';
import InvoicePage from '../pages/menu-qr/InvoicePage';
import PayPage from '../pages/menu-qr/PayPage';
import PaymentResultPage from '../pages/menu-qr/PaymentResultPage';
import RegisterPage from '../pages/register/RegisterPage';
import { RegisterProvider } from '../context/register/RegisterContext';
import TermsPage from '../pages/terms/TermsPage';
import PolicityPage from '../pages/policity/PolicityPage';
import LinkPago from '../pages/linkPago/LinkPagoPage';
import { LinkPagoProvider } from '../context/linkPago/LinkPagoContext';
import LinkPagoResult from '../pages/linkPago/LinkPagoPageResult';
import ProcessingPage from '../pages/processing/ProcessingPage';
import ThreeDSecure from '../pages/threeDsQA/threeDSecure';
import { REGISTER_ENABLED, SELF_ONBOARDING_ENABLED } from '../utils/appConfig';
import SignupPage from '../pages/signup/SignupPage';

export const AppRouter = () => {
  return (
    <Routes>

      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />

      <Route
        path="/change-password"
        element={
          <PublicRoute>
            <ChangePassword />
          </PublicRoute>
        }
      />

      <Route
        path="/register"
        element={
          REGISTER_ENABLED ? (
            <PublicRoute>
              <RegisterProvider>
                <RegisterPage />
              </RegisterProvider>
            </PublicRoute>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      {/* Registro autogestionado: el comercio elige sus funcionalidades y queda creado al finalizar */}
      <Route
        path="/signup"
        element={
          SELF_ONBOARDING_ENABLED ? (
            <PublicRoute>
              <SignupPage />
            </PublicRoute>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      <Route
        path="/terms-and-conditions"
        element={
          <PublicRoute>
            <TermsPage />
          </PublicRoute>
        }
      />

      <Route
        path="/privacy-policy"
        element={
          <PublicRoute>
            <PolicityPage />
          </PublicRoute>
        }
      />



      <Route
        path="/linkpago/*"
        element={
          <PublicRoute>
            <LinkPagoProvider>
              <LinkPago />
            </LinkPagoProvider>
          </PublicRoute>
        }
      />

      <Route
        path="/linkpago/result/*"
        element={
          <PublicRoute>
            <LinkPagoProvider>
              <LinkPagoResult />
            </LinkPagoProvider>
          </PublicRoute>
        }
      />

      <Route
        path="/voucher/*"
        element={
          <PublicRoute>
            <InvoiceProvider>
              <VoucherPage />
            </InvoiceProvider>
          </PublicRoute>
        }
      />

      <Route
        path="/ThreeDSecure/*"
        element={
          <PublicRoute>

            <ThreeDSecure />

          </PublicRoute>
        }
      />



      <Route
        path="/menuqr/confirm"
        element={
          <PublicRoute>
            <MenuQRProvider>
              <ConfirmOrderPage />
            </MenuQRProvider>
          </PublicRoute>
        }
      />
      <Route
        path="/menuqr/order"
        element={
          <PublicRoute>
            <MenuQRProvider>
              <InvoicePage />
            </MenuQRProvider>
          </PublicRoute>
        }
      />
      <Route
        path="/menuqr/pay"
        element={
          <PublicRoute>
            <MenuQRProvider>
              <PayPage />
            </MenuQRProvider>
          </PublicRoute>
        }
      />
      {/* Resultado del pago del menú QR (también es la página de retorno del 3-D Secure) */}
      <Route
        path="/menuqr/result"
        element={
          <PublicRoute>
            <MenuQRProvider>
              <PaymentResultPage />
            </MenuQRProvider>
          </PublicRoute>
        }
      />

      <Route
        path="/menuqr/*"
        element={
          <PublicRoute>
            <MenuQRProvider>
              <MenuQRPage />
            </MenuQRProvider>
          </PublicRoute>
        }
      />

      <Route
        path="/processing"
        element={
          <PublicRoute>
            <ProcessingPage />
          </PublicRoute>
        }
      />

      <Route
        path="/*"
        element={
          <PrivateRoute>
            <DashboardRoutes />
          </PrivateRoute>
        }
      />

    </Routes>
  );
};
